import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  OnDestroy,
  AfterViewInit,
} from '@angular/core';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { Subject, merge, of as observableOf } from 'rxjs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { catchError, map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { CoreService } from '../../../../services/core.service';
import { CompanyI } from '../../../../interfaces/core.interface';
import { DialogComponent } from '../../../dialog/dialog.component';
import { CompanyFormComponent } from '../../../forms/create-account/company-form/company-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-company-table',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    MatPaginator,
    MatIcon,
    MatToolbarModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    MatTooltipModule,
    CompanyFormComponent,
  ],
  templateUrl: './company-table.component.html',
  styleUrl: './company-table.component.scss',
})
export class CompanyTableComponent implements AfterViewInit, OnDestroy {
  @ViewChild('companyFormTmpl', { static: true }) companyFormTmpl!: TemplateRef<any>;
  @ViewChild('confirmDeleteTmpl', { static: true }) confirmDeleteTmpl!: TemplateRef<any>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  selectedCompany: CompanyI = {} as CompanyI;
  selectOptions: any = {};
  originalColumns: string[] = [];

  dataSource = new MatTableDataSource<CompanyI>([]);

  displayedColumns: string[] = [
    'ID',
    'Company',
    'actions',
  ];

  totalItems = 0;
  private destroy$ = new Subject<void>();

  constructor(
    private coreService: CoreService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.originalColumns = [...this.displayedColumns];
  }

  private buildQueryParams(): any {
    const pageIndex = this.paginator?.pageIndex ?? 0;
    const pageSize = this.paginator?.pageSize ?? 12;
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.sort.sortChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => (this.paginator.pageIndex = 0));

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          const params = this.buildQueryParams();
          return this.coreService.getData('/company', params).pipe(
            catchError(() => observableOf({ data: [], total: 0 }))
          );
        }),
        map((res: any) => res),
        takeUntil(this.destroy$)
      )
      .subscribe((res: any) => {
        this.dataSource.data = res.data ?? [];
        this.totalItems = res.total ?? 0;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  addNewCompany() {
    this.selectedCompany = {} as CompanyI;

    this.dialog.open(DialogComponent, {
      data: {
        content: this.companyFormTmpl,
        header: 'Add New Company',
        cls: '!bg-slate-600 !text-white',
      },
      width: '500px',
      maxWidth: '500px',
    });
  }

  editCompany(row: CompanyI) {
    this.selectedCompany = row;

    this.dialog.open(DialogComponent, {
      data: {
        content: this.companyFormTmpl,
        header: 'Edit Company',
        cls: '!bg-slate-600 !text-white',
      },
      width: '500px',
      maxWidth: '500px',
    });
  }

  openDeleteCompanyConfirm(row: CompanyI) {
    this.selectedCompany = row;
    this.dialog.open(DialogComponent, {
      data: {
        content: this.confirmDeleteTmpl,
        header: 'Delete company?',
        cls: 'bg-red-500 !text-white',
      },
    });
  }

  deleteCompany(): void {
  this.coreService
    .deleteData('manageAccount/company/delete', String(this.selectedCompany.ID))
    .subscribe({
      next: () => {
        this.onSubmitCompanyClbk();
        this.coreService.showSnackbar('Company deleted successfully');
      },
      error: (err) => {
        console.error('Delete company error:', err);
        this.onSubmitCompanyClbk();
        this.coreService.showSnackbar('You cannot delete this company');
      }
    });
}

  viewcopmanysettings(row: CompanyI): void {
    this.router.navigateByUrl('/companysettings/' + row.ID);
  }

  viewCompanyProfile(row: CompanyI): void {
    this.router.navigateByUrl('/manage-account/index-users/' + row.ID);
  }

  onSubmitCompanyClbk() {
    this.dialog.closeAll();

    const params = this.buildQueryParams();

    this.coreService.getData('/company', params).subscribe((res: any) => {
      this.dataSource.data = res.data ?? [];
      this.totalItems = res.total ?? 0;
    });
  }
  
}
